<template> 
    <tr>
        <td> {{ this.rigaParti.CodiceParte }} </td>
        <td> {{ this.rigaParti.DescrParte }} </td>
        <td> {{ this.rigaParti.Marca }} </td>
        <td> {{ this.rigaParti.Modello }} </td>
        <td> {{ this.rigaParti.Matricola }} </td>      
    </tr>
</template>

<script>

export default {
    name: "RigaGrigliaParti",
    props: {
        rigaParti: Object       
    }
} 
</script>
